module.exports = __webpack_public_path__ + "img/bg-2.27a3277e.jpg";